import { useCallback } from 'react';
import UILink from 'UIComponents/link/UILink';
import { useHubSpotAppLinkHandler } from '../context/HubSpotAppLinkHandlerContext';
import { jsx as _jsx } from "react/jsx-runtime";
export default function HubSpotAppLink({
  children,
  className,
  LinkComponent = UILink,
  LinkComponentProps = {},
  linkType,
  linkTypeProps,
  onTrackClick
}) {
  const linkHandler = useHubSpotAppLinkHandler(linkType);
  const onClick = useCallback(event => {
    if (onTrackClick) {
      onTrackClick(linkTypeProps);
    }
    if (linkHandler.onClick) {
      linkHandler.onClick(linkTypeProps, event);
    }
  }, [onTrackClick, linkHandler, linkTypeProps]);
  return /*#__PURE__*/_jsx(LinkComponent
  // Keep LinkComponentProps at the top so HubSpotAppLink props override matching ones
  , Object.assign({}, LinkComponentProps, {
    className: className,
    external: linkHandler.external,
    href: linkHandler.getHref(linkTypeProps),
    onClick: onClick,
    children: children
  }));
}